import LoginTypes from "./LoginActionTypes";

const initialState = {
  LoginPageLoading: false,
  LoginPageResponse: null,
  getSingleAMCLoading: false,
  getSingleAMCResponse: null,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LoginTypes.POST_LOGIN_REQUEST:
      return {
        ...state,
        LoginPageLoading: true,
      };

    case LoginTypes.POST_LOGIN_RESPONSE:
      return {
        ...state,
        LoginPageLoading: false,
        LoginPageResponse: action.payload,
      };

    case LoginTypes.POST_LOGIN_RESPONSE_CLEAR:
      return {
        ...state,
        LoginPageResponse: null,
      };
    //
    case LoginTypes.GET_AMC_REMINDERS_REQUEST:
      return {
        ...state,
        getSingleAMCLoading: true,
      };
    case LoginTypes.GET_AMC_REMINDERS_RESPONSE:
      return {
        ...state,
        getSingleAMCLoading: false,
        getSingleAMCResponse: action.payload,
      };
    case LoginTypes.GET_AMC_REMINDERS_RESPONSE_CLEAR:
      return {
        ...state,
        getSingleAMCResponse: null,
      };
    default:
      return state;
  }
};

export default loginReducer;
